module.exports = __webpack_public_path__ + "img/category-labware.7ad4ed4c.svg";